module.exports = __webpack_public_path__ + "static/img/qichedianzi.0d43fe2d.svg";